import React, { Component } from "react";
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import backend_url from "../../../routes/API_URL";
import swal from 'sweetalert';
import moment from "moment";

const API_URL = backend_url['api_url'];

class DivisionalProgressGraph extends Component {
  constructor(props) {
    super(props);
    
    const division_id = this.props.division_id;
   
    const end_date = new Date().getFullYear();
    const start_date = end_date - 3;
    
    this.state = {
      header: props.header ? props.header : 'years',
      GraphicalData: [],
      bearer_auth: window.sessionStorage.getItem('token'),
      division_id: division_id,
      division_name: '',
      start_date: props.start ? new Date(props.start).getFullYear() : start_date,
      end_date: props.end ? new Date(props.end).getFullYear() : end_date,
      start: props.start ? moment(props.start).startOf('year').format("YYYY-MM-DD") : moment().subtract(3, 'years').startOf('year').format("YYYY-MM-DD"),
      end: props.end ? moment(props.end).endOf('year').format("YYYY-MM-DD") : moment().endOf('year').format("YYYY-MM-DD"),
      level: props.level || '',
      loading: false,
      error: null,
      dataFetched: false
    };
  }
  
  componentDidMount() {
    this.fetchDivisionData();
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.division_id !== prevProps.division_id) {
  
      this.setState({ 
        division_id: this.props.division_id,
        dataFetched: false,
        error: null
      }, () => {
        this.fetchDivisionData();
      });
    }
  }
  
  fetchDivisionData() {
    const { division_id, start, end, level, bearer_auth } = this.state;
    
    // Validate division_id
    if (!division_id || division_id === 'undefined' || division_id === 'null' || division_id === '') {
      console.error('DivisionalProgressGraph - Invalid division ID:', division_id);
      this.setState({ 
        GraphicalData: [],
        error: 'Invalid division ID',
        loading: false,
        dataFetched: true
      });
      return;
    }

 
    this.setState({ loading: true, error: null });

    Promise.all([
      axios.get(`${API_URL}/progress_report/division/${division_id}?start_date=${start}&end_date=${end}&level=${level}`, 
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      ).catch(error => {
        console.error('Error fetching progress data:', error);
        return { data: [] };
      }),
      axios.get(`${API_URL}/divisions/${division_id}`,
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      ).catch(error => {
        console.error('Error fetching division details:', error);
        return { data: { data: [] } };
      })
    ]).then(([g_data, division_data]) => {
  
      // Handle different response formats
      let progressData = [];
      if (Array.isArray(g_data.data)) {
        progressData = g_data.data;
      } else if (g_data.data && Array.isArray(g_data.data.data)) {
        progressData = g_data.data.data;
      }
      
      // Get division name from response
      let divisionName = 'Unknown Division';
      if (division_data.data && division_data.data.length >= 1) {
        divisionName = division_data.data[0]['division_name'];
      } else if (division_data.data && division_data.data.division_name) {
        divisionName = division_data.data.division_name;
      }
      
      this.setState({
        GraphicalData: progressData,
        division_name: divisionName,
        loading: false,
        dataFetched: true
      });
    }).catch(error => {
      console.error('Error in fetchDivisionData:', error);
      this.setState({ 
        GraphicalData: [],
        error: 'Failed to load division progress data',
        loading: false,
        dataFetched: true
      });
    });
  }
  
  render() {
    const { GraphicalData, division_name, start_date, end_date, start, end, header, loading, error, dataFetched } = this.state;

    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p>Loading division progress data...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center p-5">
          <h5 className="text-danger">{error}</h5>
          <p>Division ID: {this.state.division_id || 'Not provided'}</p>
          <p>Unable to load progress data for this division.</p>
        </div>
      );
    }

    if (dataFetched && (!GraphicalData || GraphicalData.length === 0)) {
      return (
        <div className="text-center p-5">
          <h5>No Progress Data Available</h5>
          <p>Division: {division_name}</p>
          <p>There is no inspection data available for this division in the selected period.</p>
        </div>
      );
    }

    if (!GraphicalData || GraphicalData.length === 0) {
      return (
        <div className="text-center p-5">
          <h5>Loading data...</h5>
        </div>
      );
    }

    // Process data for chart
    const years = [...new Set(GraphicalData.map(item => item['DATE']))].sort();
    
    let level_one_data = new Array(years.length).fill(0);
    let level_two_data = new Array(years.length).fill(0);
    let level_three_data = new Array(years.length).fill(0);
    let level_four_data = new Array(years.length).fill(0);
    
    // Calculate percentages per year
    years.forEach((year, yearIndex) => {
      const yearData = GraphicalData.filter(item => item['DATE'] === year);
      const total = yearData.length;
      
      if (total > 0) {
        const levelCounts = {1:0, 2:0, 3:0, 4:0};
        yearData.forEach(item => {
          const level = item['level_achieved'];
          if (level && levelCounts.hasOwnProperty(level)) {
            levelCounts[level]++;
          }
        });
        
        level_one_data[yearIndex] = ((levelCounts[1] / total) * 100).toFixed(2);
        level_two_data[yearIndex] = ((levelCounts[2] / total) * 100).toFixed(2);
        level_three_data[yearIndex] = ((levelCounts[3] / total) * 100).toFixed(2);
        level_four_data[yearIndex] = ((levelCounts[4] / total) * 100).toFixed(2);
      }
    });

    const series = [
      { name: 'Level 1 - Does not meet minimum standards', data: level_one_data },
      { name: 'Level 2 - Meets Minimum Standards', data: level_two_data },
      { name: 'Level 3 - Exceeds Minimum Standards', data: level_three_data },
      { name: 'Level 4 - Effective Practice', data: level_four_data }
    ];

    const title = header === 'dates' 
      ? `${division_name} Divisional Progress Report from ${start} to ${end}`
      : `${division_name} Division Progress Report from ${start_date} to ${end_date} (${end_date - start_date + 1} Year(s))`;

    const options = {
      chart: {
        type: 'bar',
        height: 500,
        stacked: true,
        stackType: '100%'
      },
      colors: ['#ff0000', '#0018ff', '#fffc00', '#1bb60b'],
      plotOptions: {
        bar: { horizontal: false }
      },
      title: {
        text: title,
        align: 'center',
        style: { fontSize: '14px', fontWeight: 'bold' }
      },
      xaxis: {
        categories: years,
        title: { text: 'INSPECTION YEAR(S)' }
      },
      yaxis: {
        max: 100,
        title: { text: 'PERCENTAGE OF SCHOOLS' },
        labels: { formatter: (value) => value ? value + '%' : '0%' }
      },
      tooltip: {
        y: { formatter: (value) => value ? value + '%' : '0%' }
      },
      legend: { position: 'bottom' }
    };

    return (
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <ReactApexChart options={options} series={series} type="bar" height={500} />
          </div>
        </div>
      </div>
    );
  }
}

export default DivisionalProgressGraph;